<template>
  <div class="page-container">
    <el-card>
      <!-- 搜索区 -->
      <div class="search-bar">
        <el-input
          v-model="query.keyword"
          placeholder="合伙人姓名 或 联系方式"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleSearch"
        />
        <el-checkbox v-model="hideRejected" @change="handleSearch">不通过的不显示</el-checkbox>
        <el-button type="primary" size="mini" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" icon="el-icon-refresh" @click="handleReset">重置</el-button>
      </div>

      <!-- 表格 -->
      <el-table ref="table" :data="tableData" v-loading="loading" border stripe style="width: 100%">
        <el-table-column prop="id" label="ID" min-width="100" />
        <el-table-column prop="name" label="姓名" min-width="100" />
        <el-table-column prop="phone" label="手机号" width="140" />
        <el-table-column label="头像" width="70" align="center">
          <template slot-scope="{ row }">
            <el-avatar v-if="row.avatar" :size="36" :src="row.avatar" />
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="绑定客户数" width="100" align="center">
          <template slot-scope="{ row }">
            <span class="count-num">{{ row.bound_user_count ?? 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="绑定用户数" width="100" align="center">
          <template slot-scope="{ row }">
            <span class="count-num">{{ row.bound_contact_count ?? 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="申请日期" min-width="160">
          <template slot-scope="{ row }">
            <span :class="row.review_status === 2 ? 'date-rejected' : ''">
              {{ row.created_at || '—' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="reviewStatusType(row.review_status)" size="small">
              {{ reviewStatusLabel(row.review_status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="审核人" width="100">
          <template slot-scope="{ row }">{{ row.reviewed_by || '—' }}</template>
        </el-table-column>
        <el-table-column label="审核时间" min-width="160">
          <template slot-scope="{ row }">
            <span :class="row.review_status === 2 ? 'date-rejected' : ''">
              {{ row.reviewed_at || '—' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="320" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-permission="['partner:detail']"
              type="primary" size="mini" icon="el-icon-view"
              @click="handleDetail(row)"
            >详情</el-button>
            <el-button
              v-permission="['partner:memberList']"
              type="success" size="mini" icon="el-icon-user"
              @click="openMemberList(row)"
            >客户列表</el-button>
            <el-button
              v-permission="['partner:orderContactList']"
              type="success" size="mini" icon="el-icon-s-order"
              @click="openContactList(row)"
            >用户列表</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :current-page="query.page"
        :page-sizes="[10, 15, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 16px; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 绑定客户列表弹窗 -->
    <el-dialog
      :title="`${memberDialog.partnerName} 的客户列表`"
      :visible.sync="memberDialog.visible"
      width="860px"
      @close="resetMemberDialog"
    >
      <el-table
        :data="memberDialog.list"
        v-loading="memberDialog.loading"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="头像" width="66" align="center">
          <template slot-scope="{ row }">
            <el-avatar v-if="row.avatar" :size="32" :src="row.avatar" />
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
        <el-table-column label="昵称" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.nickname || '—' }}</template>
        </el-table-column>
        <el-table-column label="手机号" width="140">
          <template slot-scope="{ row }">{{ row.phone || '未绑定' }}</template>
        </el-table-column>
        <el-table-column prop="created_at" label="注册时间" width="160" />
      </el-table>
      <el-pagination
        :current-page="memberDialog.page"
        :page-sizes="[10, 15, 20]"
        :page-size="memberDialog.pageSize"
        :total="memberDialog.total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 14px; text-align: right"
        @size-change="val => { memberDialog.pageSize = val; memberDialog.page = 1; fetchMemberList() }"
        @current-change="val => { memberDialog.page = val; fetchMemberList() }"
      />
    </el-dialog>

    <!-- 绑定订单用户列表弹窗 -->
    <el-dialog
      :title="`${contactDialog.partnerName} 的订单用户列表`"
      :visible.sync="contactDialog.visible"
      width="860px"
      @close="resetContactDialog"
    >
      <el-table
        :data="contactDialog.list"
        v-loading="contactDialog.loading"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="name" label="姓名" width="120">
          <template slot-scope="{ row }">{{ row.name || '—' }}</template>
        </el-table-column>
        <el-table-column label="手机号" width="140">
          <template slot-scope="{ row }">{{ row.phone || '—' }}</template>
        </el-table-column>
        <el-table-column label="性别" width="70" align="center">
          <template slot-scope="{ row }">{{ genderLabel(row.gender) }}</template>
        </el-table-column>
        <el-table-column label="年龄" width="70" align="center">
          <template slot-scope="{ row }">{{ row.age != null ? row.age + ' 岁' : '—' }}</template>
        </el-table-column>
        <el-table-column label="备注" min-width="160" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.remark || '—' }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="contactDialog.page"
        :page-sizes="[10, 15, 20]"
        :page-size="contactDialog.pageSize"
        :total="contactDialog.total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 14px; text-align: right"
        @size-change="val => { contactDialog.pageSize = val; contactDialog.page = 1; fetchContactList() }"
        @current-change="val => { contactDialog.page = val; fetchContactList() }"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getPartnerList, getPartnerMemberList, getPartnerOrderContactList } from '@/api/partner'

export default {
  name: 'PartnerList',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      hideRejected: false,
      query: { page: 1, pageSize: 15, keyword: '' },

      // 绑定客户列表弹窗
      memberDialog: {
        visible: false,
        loading: false,
        partnerId: null,
        partnerName: '',
        list: [],
        total: 0,
        page: 1,
        pageSize: 15
      },

      // 绑定订单用户列表弹窗
      contactDialog: {
        visible: false,
        loading: false,
        partnerId: null,
        partnerName: '',
        list: [],
        total: 0,
        page: 1,
        pageSize: 15
      }
    }
  },
  created() {
    this.fetchData()
  },
  activated() {
    this.fetchData()
  },
  methods: {
    reviewStatusLabel(val) {
      return { 0: '未审核', 1: '已通过', 2: '不通过' }[val] ?? '—'
    },
    reviewStatusType(val) {
      return { 0: '', 1: 'success', 2: 'danger' }[val] ?? 'info'
    },

    // ── 列表 ────────────────────────────────────────────────
    async fetchData() {
      this.loading = true
      try {
        const params = {
          page: this.query.page,
          pageSize: this.query.pageSize,
          hide_rejected: this.hideRejected ? 1 : 0
        }
        if (this.query.keyword) params.keyword = this.query.keyword
        const res = await getPartnerList(params)
        this.tableData = res.data.list
        this.total = res.data.total
        this.$nextTick(() => this.$refs.table && this.$refs.table.doLayout())
      } finally {
        this.loading = false
      }
    },

    handleSearch() { this.query.page = 1; this.fetchData() },
    handleReset() {
      this.query = { page: 1, pageSize: 10, keyword: '' }
      this.hideRejected = false
      this.fetchData()
    },
    handleSizeChange(val) { this.query.pageSize = val; this.query.page = 1; this.fetchData() },
    handleCurrentChange(val) { this.query.page = val; this.fetchData() },

    handleDetail(row) {
      this.$router.push({ path: '/partner/detail', query: { id: row.id } })
    },

    genderLabel(g) {
      if (g === 1) return '男'
      if (g === 2) return '女'
      return '—'
    },

    // ── 绑定客户列表 ─────────────────────────────────────────
    openMemberList(row) {
      this.memberDialog.partnerId   = row.id
      this.memberDialog.partnerName = row.name || row.phone
      this.memberDialog.page        = 1
      this.memberDialog.pageSize    = 15
      this.memberDialog.visible     = true
      this.fetchMemberList()
    },

    resetMemberDialog() {
      this.memberDialog.list  = []
      this.memberDialog.total = 0
      this.memberDialog.page  = 1
    },

    async fetchMemberList() {
      this.memberDialog.loading = true
      try {
        const res = await getPartnerMemberList({
          partner_id: this.memberDialog.partnerId,
          page:       this.memberDialog.page,
          pageSize:   this.memberDialog.pageSize
        })
        const d = res.data || {}
        this.memberDialog.list  = d.list || []
        this.memberDialog.total = d.total || 0
      } finally {
        this.memberDialog.loading = false
      }
    },

    // ── 绑定订单用户列表 ─────────────────────────────────────
    openContactList(row) {
      this.contactDialog.partnerId   = row.id
      this.contactDialog.partnerName = row.name || row.phone
      this.contactDialog.page        = 1
      this.contactDialog.pageSize    = 15
      this.contactDialog.visible     = true
      this.fetchContactList()
    },

    resetContactDialog() {
      this.contactDialog.list  = []
      this.contactDialog.total = 0
      this.contactDialog.page  = 1
    },

    async fetchContactList() {
      this.contactDialog.loading = true
      try {
        const res = await getPartnerOrderContactList({
          partner_id: this.contactDialog.partnerId,
          page:       this.contactDialog.page,
          pageSize:   this.contactDialog.pageSize
        })
        const d = res.data || {}
        this.contactDialog.list  = d.list || []
        this.contactDialog.total = d.total || 0
      } finally {
        this.contactDialog.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-muted    { color: #c0c4cc; font-size: 12px; }
.date-rejected { color: #e6a23c; }
.count-num     { font-weight: 600; color: #409eff; }
</style>
